import { combineAuth } from './hr-authority';

export class HrCommonAuthority {

    public static readonly HR_BASE = "kovan:hr";
    // public static readonly EDIT = "edit";
    // public static readonly READ = "edit:read";

    constructor(authority: string) {
        this.BASE = combineAuth(HrCommonAuthority.HR_BASE, authority);
        // this.EDIT = combineAuth(this.BASE, HrCommonAuthority.EDIT);
        // this.READ = combineAuth(this.BASE, HrCommonAuthority.READ);
    }

    public readonly BASE:string;
    // public readonly EDIT: string;
    // public readonly READ: string;
}
